module.exports = __webpack_public_path__ + "static/media/file-png-icon.344bc1b5.svg";